<mat-toolbar
  class="bottom-navbar"
  *ngIf="!_isProfilePicLoading && _hasPic"
  [ngClass]="{
    'dark-theme': _theme === 'dark-theme',
    'light-theme': _theme === 'light-theme',
    'paper-theme': _theme === 'paper-theme',
  }"
>
  <a
    class="nav-item"
    routerLink="/home"
    routerLinkActive="active"
    [ngClass]="{
      'ddc-icon-gradient-light': _isLightTheme,
      'ddc-icon-gradient-dark': _isDarkTheme,
      'ddc-icon-gradient-paper': _isPaperTheme,
    }"
  >
    <mat-icon>home</mat-icon>
  </a>

  <a
    class="nav-item"
    routerLink="/search"
    routerLinkActive="active"
    [ngClass]="{
      'ddc-icon-gradient-light': _isLightTheme,
      'ddc-icon-gradient-dark': _isDarkTheme,
      'ddc-icon-gradient-paper': _isPaperTheme,
    }"
  >
    <mat-icon>search</mat-icon>
  </a>

  <a
    class="nav-item"
    routerLink="/store"
    routerLinkActive="active"
    [ngClass]="{
      'ddc-icon-gradient-light': _isLightTheme,
      'ddc-icon-gradient-dark': _isDarkTheme,
      'ddc-icon-gradient-paper': _isPaperTheme,
    }"
  >
    <mat-icon>explore</mat-icon>
  </a>

  <button class="create-button" (click)="openMobileAddDialog()">
    <mat-icon
      class="bg-gradient-to-r hover:bg-gradient-to-br"
      [ngClass]="{
        'ddc-icon-gradient-light': _isLightTheme,
        'ddc-icon-gradient-dark': _isDarkTheme,
        'ddc-icon-gradient-paper': _isPaperTheme,
      }"
      >add_circle</mat-icon
    >
  </button>
  <a
    class="nav-item"
    routerLink="/library"
    routerLinkActive="active"
    [ngClass]="{
      'ddc-icon-gradient-light': _isLightTheme,
      'ddc-icon-gradient-dark': _isDarkTheme,
      'ddc-icon-gradient-paper': _isPaperTheme,
    }"
  >
    <mat-icon>apps</mat-icon>
  </a>
  <a
    class="nav-item"
    routerLink="/saved"
    routerLinkActive="active"
    [ngClass]="{
      'ddc-icon-gradient-light': _isLightTheme,
      'ddc-icon-gradient-dark': _isDarkTheme,
      'ddc-icon-gradient-paper': _isPaperTheme,
    }"
  >
    <mat-icon>bookmark</mat-icon>
  </a>

  <button class="profile-nav-item" [matMenuTriggerFor]="beforeMenu">
    <div class="user-profile-picture">
      <img
        class="user-pic-rounded"
        *ngIf="!_isProfilePicLoading || _hasPic"
        alt="Profile Picture"
        [src]="_userProfilePic"
      />
      <img class="rounded-lg" *ngIf="_isProfilePicLoading || !_hasPic" [src]="_DefaultProfilePic" />
    </div>
    <!-- <span>Profile</span> -->
  </button>

  <!-- Account/Setting Menu -->
  <mat-menu
    #beforeMenu="matMenu"
    class="account-menu bottom-navbar-menu"
    xPosition="before"
    yPosition="above"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
  >
    <button class="margin-right-10" mat-menu-item [routerLink]="['/users', _username]">
      <mat-icon>account_circle</mat-icon>
      <span class="setting-text-font">View Profile</span>
    </button>
    <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/pricing']">
      <mat-icon>workspace_premium</mat-icon>
      <span class="setting-text-font">Upgrade</span>
    </button>
    <!-- <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/agents']">
      <mat-icon>psychology</mat-icon>
      <span class="setting-text-font">Agents</span>
    </button> -->
    <button
      class="margin-right-10 ai-btn-container"
      mat-menu-item
      routerLinkActive="router-link-active"
      [routerLink]="['/lingo']"
    >
      <div style="display: flex; align-items: center; gap: 18px">
        <img class="ai-btn-logo" alt="Lingo AI" [src]="'assets/media/logos/lingo_logo_light.png'" />
        <span class="setting-text-font">Lingo AI</span>
      </div>
    </button>
    <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/canvas']">
      <mat-icon>dashboard</mat-icon>
      <span class="setting-text-font">Canvas</span>
    </button>
    <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/network']">
      <mat-icon>people_outline</mat-icon>
      <span class="setting-text-font">Network</span>
    </button>
    <button
      class="margin-right-10"
      mat-menu-item
      routerLinkActive="router-link-active"
      [routerLink]="['/notifications']"
    >
      <mat-icon>notifications</mat-icon>
      <span class="setting-text-font">Notifications</span>
    </button>
    <button class="margin-right-10" mat-menu-item routerLinkActive="router-link-active" [routerLink]="['/settings']">
      <mat-icon>settings</mat-icon>
      <span class="setting-text-font">Settings</span>
    </button>
    <button
      class="margin-right-10"
      *ngIf="_isAdmin"
      mat-menu-item
      routerLinkActive="router-link-active"
      [ngClass]="{ adminNavbar: _isAdmin }"
      [routerLink]="['/admin']"
    >
      <mat-icon>admin_panel_settings</mat-icon>
      <span class="setting-text-font">Admin Panel</span>
    </button>
    <mat-divider></mat-divider>

    <button class="margin-right-10 sign-out-btn" mat-menu-item (click)="openLogOutDialog()">
      <mat-icon class="sign-out-btn-icon">account_circle</mat-icon>
      <span class="setting-text-font">Sign Out</span>
    </button>
  </mat-menu>
</mat-toolbar>
